// extracted by mini-css-extract-plugin
module.exports = {"setVizStyle":"VistaAños_setVizStyle__2BTD9","viz":"VistaAños_viz__1VjZu"};